(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-gallery"] && !Shopify.designMode) return;
  try {
    function initArticleGalleryCarousel() {
    const splideElements = document.querySelectorAll('.article-gallery-carousel');
  
    splideElements.forEach(function(splideEl) {

      if (splideEl.splideInstance) {
        splideEl.splideInstance.destroy();
      }

      let splideOptions = {
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: false,
        drag: true,
        speed: 600
      }

      const splide = new Splide(splideEl, splideOptions);

      const navigation = splide.root.querySelector('.carousel-navigation');
      const bar = navigation.querySelector('.carousel-navigation-progress-bar');

      function updateProgress() {
        if (!bar) return;

        const total = splide.length;
        const perPage = splide.options.perPage;
        const currentIndex = splide.index;

        const covered = Math.min(currentIndex + perPage, total);
        
        const progress = total === 0 ? 0 : covered / total;

        bar.style.width = (progress * 100) + '%';
      }

      splide.on( 'overflow', function ( isOverflow ) {
        splide.options = {
          drag      : isOverflow,
        };

        if (navigation) {
          navigation.style.display = isOverflow ? 'flex' : 'none';
        }
      } );

      splide.on('mounted move', updateProgress);

      splideEl.splideInstance = splide;
      splide.mount();
  });
}

document.addEventListener('DOMContentLoaded', initArticleGalleryCarousel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["article-links"] && !Shopify.designMode) return;
  try {
    class ArticleLinks extends HTMLElement {
    constructor() {
      super();

      this.articleContent = document.querySelector('.js-article-content');
      this.list = this.querySelector('ul');
      this.toggleButton = this.querySelector('.article__links__btn-mobile');
      this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
      this.mainContent = document.querySelector('#MainContent');
      this.headerSection = document.querySelector('.section--article-header');
      this.articleDetails = document.querySelector('.section--article-details');
      this.articleFaq = document.querySelector('.section--article-faq');
      this.articleFooter = document.querySelector('.section--article-footer');

      this.headerSectionHeight = this.headerSection ? this.headerSection.offsetHeight : 0;
      this.sidebarNaturalTop = null;
      this._updatePositionBound = this.updatePosition.bind(this);

      if (this.articleContent) {
        this.generateLinks();
      }

      if (this.isDesktop && !this.classList.contains('hidden')) {
        this.initStickyBehavior();
      }

      if (this.toggleButton) {
        this.toggleButton.addEventListener('click', (e) => {
          e.stopPropagation();
          this.classList.toggle('active');
        });
      }

      if (!this.isDesktop) {
        document.addEventListener('click', this.handleOutsideClick.bind(this));
      }

      window.addEventListener('resize', () => {
        const wasDesktop = this.isDesktop;
        this.isDesktop = window.matchMedia('(min-width: 990px)').matches;

        if (!wasDesktop && this.isDesktop) {
          this.classList.remove('active');
          document.removeEventListener('click', this.handleOutsideClick.bind(this));

          if (!this.classList.contains('hidden')) {
            this.cleanupSticky();
            this.initStickyBehavior();
          }
        } else if (wasDesktop && !this.isDesktop) {
          this.cleanupSticky();
          document.addEventListener('click', this.handleOutsideClick.bind(this));
        }
      });
    }

    initStickyBehavior() {
      this.sidebarNaturalTop = null;
      window.addEventListener('scroll', this._updatePositionBound);
      requestAnimationFrame(() => this.updatePosition());
    }

    cleanupSticky() {
      window.removeEventListener('scroll', this._updatePositionBound);
      this.classList.remove('is-fixed');
      this.style.position = '';
      this.style.top = '';
      this.sidebarNaturalTop = null;
    }

    handleOutsideClick(event) {
      if (!this.contains(event.target) && !event.target.closest('.article__links__btn-mobile')) {
        this.classList.remove('active');
      }
    }

    updatePosition() {
      if (!this.isDesktop || this.classList.contains('hidden')) return;

      const stopElement = this.getStopElement();
      if (!stopElement) return;

      const scrollTop = window.scrollY;
      const sidebarHeight = this.offsetHeight;
      const offsetTop = 32;

      const stopBottom = stopElement.getBoundingClientRect().bottom + window.scrollY;

      if (scrollTop + offsetTop + sidebarHeight >= stopBottom) {
        this.classList.remove('is-fixed');
        this.style.position = 'absolute';

        const parentTop = this.offsetParent.getBoundingClientRect().top + window.scrollY;
        const absoluteTop = stopBottom - sidebarHeight - parentTop;

        this.style.top = `${absoluteTop}px`;
        return;
      }

      if (this.headerSection) {
        const headerBottom = this.headerSection.getBoundingClientRect().bottom + window.scrollY;

        if (scrollTop >= headerBottom) {
          this.applyFixedStyles(offsetTop);
        } else {
          this.classList.remove('is-fixed');
          this.style.position = 'absolute';
          this.style.top = `${this.headerSectionHeight}px`;
        }
        return;
      }

      if (this.sidebarNaturalTop === null) {
        const rect = this.getBoundingClientRect();
        this.sidebarNaturalTop = rect.top + window.scrollY - offsetTop;
      }

      if (scrollTop >= this.sidebarNaturalTop) {
        this.applyFixedStyles(offsetTop);
      } else {
        this.classList.remove('is-fixed');
        this.style.position = '';
        this.style.top = '';
      }
    }

    applyFixedStyles(offset) {
      this.classList.add('is-fixed');
      this.style.position = 'fixed';
      this.style.top = `${offset}px`;
    }

    getStopElement() {
      return this.articleFooter || this.articleFaq || this.articleDetails || null;
    }

    generateLinks() {
      const sections = [this.articleDetails, this.articleFaq].filter(Boolean);

      const headings = [];

      sections.forEach((section) => {
        const sectionHeadings = section.querySelectorAll('h2');
        headings.push(...sectionHeadings);
      });

      if (headings.length) {
        headings.forEach((heading, index) => {
          heading.classList.add(`js-anchor-link-${index}`);
          const li = document.createElement('li');

          if (this.animateContent) {
            li.classList.add('scroll-trigger', 'animate--slide-in');
            li.style.setProperty('--animation-order', index);
          }

          li.innerHTML = `
          <span>${index + 1}.</span>
          <span class="article-link__title">${heading.innerText}</span>
          <span class="article-link__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M6.93262 2.4326C7.10838 2.21978 7.42379 2.18959 7.63672 2.36522L11.5752 5.6162C11.6902 5.71116 11.7568 5.85282 11.7568 6.00194C11.7568 6.15105 11.6902 6.29274 11.5752 6.38768L7.63672 9.63866C7.4238 9.81428 7.10839 9.78407 6.93262 9.57127C6.75689 9.35835 6.78714 9.04297 7 8.86717L9.86523 6.50194H0.753906C0.478001 6.50175 0.254029 6.27786 0.253906 6.00194C0.253966 5.72596 0.477962 5.50213 0.753906 5.50194H9.86523L7 3.1367C6.78716 2.96094 6.75698 2.64554 6.93262 2.4326Z" fill="#282828"/>
            </svg>
          </span>
        `;
          li.setAttribute('data-index', index);
          this.list.appendChild(li);
          this.mainContent?.classList.add('has-article-sidebar');

          li.addEventListener('click', (e) => {
            e.stopPropagation();
            const target = document.querySelector(`.js-anchor-link-${index}`);
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
              if (!this.isDesktop) this.classList.remove('active');
            }
          });
        });
      } else {
        this.classList.add('hidden');
        if (this.isDesktop) this.cleanupSticky();
      }
    }
  }

  customElements.define('article-links', ArticleLinks);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-post-card"] && !Shopify.designMode) return;
  try {
    class ArticleCard extends HTMLElement {
    constructor() {
      super();

      if (window.innerWidth <= 1024) return;

      this.cta = this.querySelector('.blog-post-card__cta');
      if (!this.cta) return;

      this.addEventListener('mouseenter', () => {
        const width = this.cta.scrollWidth + 7;
        this.cta.style.setProperty('--cta-width', `${width}px`);
        this.cta.classList.add('active');
      });

      this.addEventListener('mouseleave', () => {
        this.cta.classList.remove('active');
      });
    }
  }

  customElements.define('article-card', ArticleCard);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-discount"] && !Shopify.designMode) return;
  try {
    class CartDiscounts extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('.custom-discounts__form');
      this.input = this.form?.querySelector('input[name="custom-discounts__input"]');
      this.submitBtn = this.form?.querySelector('.submit-discount__button');
      this.errorEl = this.form?.querySelector('.error');
      this.list = this.querySelector('.cart-discounts__list');

      this.submitBtn?.addEventListener('click', this.applyDiscount.bind(this));
      this.list?.addEventListener('click', this.handleRemove.bind(this));
    }

    async applyDiscount() {
      const code = this.input?.value.trim();
      if (!code) return this.showError(this.dataset.emptyCodeMessage || 'Enter a discount code');

      this.hideError();

      try {
        const formData = new FormData();
        formData.append('discount', code);

        const updateRes = await fetch('/cart/update.js', {
          method: 'POST',
          body: formData,
        });

        if (!updateRes.ok) throw new Error('Failed to update cart');

        const cartData = await this.fetchCartData();
        const applied = this.getAppliedDiscountCodes(cartData);

        if (!applied.includes(code)) {
          this.showError(this.dataset.invalidCodeMessage || 'Invalid discount code');
          return;
        }

        this.renderDiscountList(applied, this.getAllDiscountTitles(cartData));
        this.input.value = '';
        publish(PUB_SUB_EVENTS.cartUpdate);
      } catch (err) {
        console.error('Apply discount error:', err);
        this.showError(this.dataset.errorMessage || 'Something went wrong');
      }
    }

    handleRemove(e) {
      const removeBtn = e.target.closest('.remove-discount');
      if (!removeBtn) return;

      const codeToRemove = removeBtn.dataset.code;
      if (!codeToRemove) return;

      this.removeDiscount(codeToRemove);
    }

    async removeDiscount(code) {
      try {
        const cartData = await this.fetchCartData();
        const allCodes = this.getAppliedDiscountCodes(cartData);
        const updatedCodes = allCodes.filter((c) => c !== code).join(',');

        const formData = new FormData();
        formData.append('discount', updatedCodes);

        await fetch('/cart/update.js', {
          method: 'POST',
          body: formData,
        });

        const freshCartData = await this.fetchCartData();
        this.renderDiscountList(this.getAppliedDiscountCodes(freshCartData), this.getAllDiscountTitles(freshCartData));

        publish(PUB_SUB_EVENTS.cartUpdate);
      } catch (err) {
        console.error('Remove discount error:', err);
      }
    }

    async fetchCartData() {
      const res = await fetch('/cart.js');
      return res.json();
    }

    getAppliedDiscountCodes(cart) {
      const codes = new Set();

      cart.cart_level_discount_applications.forEach((d) => {
        if (d.type === 'discount_code') codes.add(d.title);
      });

      cart.items.forEach((item) => {
        item.line_level_discount_allocations.forEach((a) => {
          if (a.discount_application.type === 'discount_code') {
            codes.add(a.discount_application.title);
          }
        });
      });

      return Array.from(codes);
    }

    getAllDiscountTitles(cart) {
      const titles = new Set();

      cart.cart_level_discount_applications.forEach((d) => titles.add(d.title));
      cart.items.forEach((item) => {
        item.line_level_discount_allocations.forEach((a) => {
          titles.add(a.discount_application.title);
        });
      });

      return Array.from(titles);
    }

    renderDiscountList(appliedCodes, allTitles) {
      if (!this.list) return;

      this.list.innerHTML = allTitles
        .map((title) => {
          const isRemovable = appliedCodes.includes(title);
          const closeButton = isRemovable
            ? `<span class="remove-discount" data-code="${title}">${this.getCloseIcon()}</span>`
            : '';
          return `<li class="discounts__discount discounts__discount--position">
                <span>${this.escapeHtml(title)}</span>
                ${closeButton}
              </li>`;
        })
        .join('');
    }

    getCloseIcon() {
      return '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7227 0.219727C11.0156 -0.0731312 11.4903 -0.0731549 11.7832 0.219727C12.0759 0.51262 12.076 0.987425 11.7832 1.28027L7.0625 6.00098L11.7832 10.7227C12.0759 11.0156 12.076 11.4904 11.7832 11.7832C11.4904 12.076 11.0155 12.0759 10.7227 11.7832L6.00098 7.0625L1.28027 11.7832C0.987432 12.0759 0.512599 12.0759 0.219727 11.7832C-0.0731283 11.4903 -0.07306 11.0156 0.219727 10.7227L4.93945 6.00098L0.219727 1.28027C-0.0731557 0.987391 -0.0731347 0.512623 0.219727 0.219727C0.512619 -0.0731659 0.98738 -0.0731651 1.28027 0.219727L6.00098 4.93945L10.7227 0.219727Z" fill="currentColor"/></svg>';
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    showError(message) {
      if (this.errorEl) {
        this.errorEl.textContent = message;
        this.errorEl.style.display = 'block';
      }
    }

    hideError() {
      if (this.errorEl) {
        this.errorEl.style.display = 'none';
      }
    }
  }

  customElements.define('cart-discounts', CartDiscounts);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-form-stages"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const forms = document.querySelectorAll("[data-stage]");
    const stageSelect = document.querySelector("[data-stage-select]");

    function updateEmbed(event) {
      const selectedStage = stageSelect.value;

      forms.forEach(form => {
        if (form.getAttribute('data-stage') === selectedStage) {
          form.classList.remove("contact-form__form--hidden");
        } else {
          form.classList.add("contact-form__form--hidden");
        }
      });
    }

    stageSelect?.addEventListener("change", event => updateEmbed());

    // On a successful submit the app swaps the form inside its shadow DOM for a
    // confirmation message, but the dropdown/title/intro live outside it. Watch
    // each embed's shadowRoot and, once the form is replaced by the confirmation,
    // flag the section so those elements hide (CSS in contact-form.liquid).
    const section = stageSelect?.closest('.contact-form');
    if (!section) return;

    function watchSuccess(embed) {
      const sr = embed.shadowRoot;
      let seenForm = false;

      function check() {
        if (sr.querySelector('form')) {
          seenForm = true;
          return false;
        }
        // Form is gone after we'd seen it => submitted successfully.
        if (seenForm) {
          section.classList.add('contact-form--submitted');
          return true;
        }
        return false;
      }

      if (check()) return;

      const observer = new MutationObserver(function () {
        if (check()) observer.disconnect();
      });
      // Watch childList + attributes per the third-party-widget convention.
      observer.observe(sr, { childList: true, subtree: true, attributes: true });
    }

    // The shadowRoot attaches on hydration (not observable from the document),
    // so poll each embed (bounded) until its shadowRoot is ready.
    function ensureWatched(embed, attempts) {
      if (embed.shadowRoot) {
        watchSuccess(embed);
        return;
      }

      if (attempts <= 0) return;

      requestAnimationFrame(function () {
        ensureWatched(embed, attempts - 1);
      });
    }

    // The app injects <shopify-forms-embed> AFTER DOMContentLoaded, so a one-time
    // query is empty. Scan now and whenever the section's DOM changes.
    function scanEmbeds() {
      section.querySelectorAll('shopify-forms-embed').forEach(function (embed) {
        if (embed.dataset.ttSuccessInit === 'true') return;
        embed.dataset.ttSuccessInit = 'true';
        ensureWatched(embed, 300); // ~5s at 60fps — covers slow hydration
      });
    }

    scanEmbeds();
    new MutationObserver(scanEmbeds).observe(section, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-app-styling"] && !Shopify.designMode) return;
  try {
    (function () {
    const selector = '[data-contact-form] shopify-forms-embed';

    function injectStyle(form) {
      // Each embed has its own shadow DOM; skip until it's ready and only inject once.
      if (!form.shadowRoot || form.dataset.ttStyled === 'true') return;

      const style = document.createElement('style');

      style.textContent = `
        form {
          --gap: 0;
          --height-input: 4.6rem;
          --font-size-input: var(--font-size-14);
          --form-field-border: 0 0 0 0.15rem rgba(40, 40, 40, 0.48);
        }

        ._formContainer_1q1d2_30 {
          margin: 0 !important;
          max-width: none !important;
          width: 100% !important;
        }

        form ._formFieldContainer_1mxsl_5 {
          flex-direction: column-reverse !important;
          gap: 1.4rem !important;
        }

        form ._formFieldContainer_1mxsl_5  label,
        form ._birthdayText_rzr7e_15,
        form ._formFileInput_ehvsf_1 p,
        form ._selectContainer_12thd_6 p {
          color: var(--color-foreground) !important;
          font-family: var(--font-heading--family) !important;
          font-weight: var(--font-heading--weight) !important;
          font-size: var(--font-size-16) !important;
          position: static !important;
          transform: none !important;
        }

        form ._dateFieldContainer_rzr7e_5 label {
          font-size: var(--font-size-14) !important;
          transform: translateY(9px) !important;
        }

        form._formFieldset_cit2d_82 {
          gap: 0 !important;
        }

        #app-embed ._container_3eyaa_70 {
          display: block !important;
        }

        #app-embed ._formDisclaimer_cit2d_38 p {
          font-size: var(--font-size-14) !important;
          font-family: var(--font-primary--family) !important;
          margin-top: 2.4rem !important;
          text-wrap: pretty !important;
        }

        form ._formFieldContainer_1mxsl_5 input[type="text"],
        form ._formFieldContainer_1mxsl_5 textarea {
          border-radius: 0.6rem !important;
          font-size: var(--font-size-input) !important;
          font-weight: 300 !important;
          font-family: var(--font-primary--family) !important;
          height: calc(var(--height-input) - 0.2rem) !important;
          padding: 0 1.6rem !important;
        }

        form ._selectToggleText_12thd_25 {
          font-size: var(--font-size-input) !important;
          font-family: var(--font-primary--family) !important;
        }

        form ._arrowDownIcon_12thd_19 svg {
          opacity: 0;
        }
        
        form ._arrowDownIcon_12thd_19 {
          position: relative;
          width: 0.9rem;
          height: 0.9rem;
          transform: rotate(45deg);
          margin-top: 0.2rem;
        }

        form ._arrowDownIcon_12thd_19:after,
        form ._arrowDownIcon_12thd_19:before {
          content: "";
          position: absolute;
          background: var(--form-text-color, currentColor);
          border-radius: 0.2rem;
        }

        form ._arrowDownIcon_12thd_19:after {
          top: 0;
          right: 0;
          width: 0.1rem;
          height: 100%;
        }

        form ._arrowDownIcon_12thd_19:before {
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.1rem;
        }

        form ._formFieldContainer_1mxsl_5 textarea {
          padding: 2.2rem 1.6rem !important;
          min-height: 15rem
        }

        @media screen and (min-width: 750px) {
          form {
            --height-input: 5.6rem;
            --font-size-input: var(--font-size-16);
            --form-field-border: 0 0 0 0.1rem rgba(40, 40, 40, 0.48);
          }

          form ._formFieldContainer_1mxsl_5 textarea {
            min-height: 20.8rem
          }

          form ._arrowDownIcon_12thd_19 {
            margin-top: 0.6rem;
          }
        }

        form input::-webkit-input-placeholder {
          opacity: 1 !important;
        }

        form ._selectContainer_12thd_6 button {
          height: var(--height-input) !important;
          max-height: var(--height-input) !important;
          border-radius: 0.6rem !important;
        }

        form ._formFileInput_ehvsf_1 button {
          padding: 0 !important;
        }

        form button[type="submit"] {
          position: relative;
          border-radius: 3rem !important;
          margin-left: auto !important;
          width: stretch !important;
          font-size: var(--font-size-14) !important;
          font-family: var(--font-primary--family) !important;
          padding: 1.3rem 4.2rem 1.3rem 1.6rem !important;
          margin-top: 3.2rem !important; 
          justify-content: flex-start;
        }

        form button[type="submit"]:after {
          content: "";
          position: absolute;
          top: 1.3rem;
          right: 1.6rem;
          width: 1.4rem;
          height: 1.4rem;
          display: block;
          background-repeat: no-repeat;
          background-size: contain;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'%3E%3Cpath d='M10.4004 3.64822C10.6641 3.32938 11.1368 3.28435 11.4561 3.54763L17.3643 8.42361C17.5367 8.56601 17.6366 8.77906 17.6367 9.00271C17.6366 9.22619 17.5365 9.43843 17.3643 9.58083L11.4551 14.4568C11.1356 14.7203 10.663 14.6756 10.3994 14.3562C10.1362 14.0368 10.1827 13.5641 10.502 13.3006L14.7988 9.75271H1.13281C0.718723 9.75269 0.382987 9.41676 0.382812 9.00271C0.382981 8.58865 0.718719 8.25273 1.13281 8.25271H14.7998L10.502 4.70486C10.1825 4.44118 10.1367 3.96766 10.4004 3.64822Z' fill='%23FFFFFF'/%3E%3C/svg%3E");
        }

        form > div:not(:nth-child(2)) {
          margin-top: 2.4rem !important;
        }

        ._formBannerContainer_z5ku3_1 ._formBannerHeading_z5ku3_9 {
          font-size: var(--font-size-title-form) !important;
          font-family: var(--font-heading--family) !important;
          font-weight: var(--font-heading--weight) !important;
          margin-bottom: 1.6rem !important;
        }

        @media screen and (min-width: 750px) {
          form > div:not(:nth-child(2)) {
            margin-top: 2.8rem !important;
          }

          form button[type="submit"] {
            width: fit-content !important;
            font-size: var(--font-size-16) !important;
          }

          form button[type="submit"]:after {
            width: 1.8rem;
            height: 1.8rem;
          }

          form ._formFieldContainer_1mxsl_5 input[type="text"],
          form ._formFieldContainer_1mxsl_5 textarea,
          form ._selectContainer_12thd_6 button {
            border-width: 0.1rem;
          }
        }

        form output {
          font-size: var(--font-size-14) !important;
          font-family: var(--font-primary--family) !important;
          margin-top: 1.2rem;
        }

        form > div:last-of-type {
          position: relative;
          padding-bottom: 3.2rem !important;
        }

        form > div:last-of-type:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 0.1rem;
          background-color: #F0F0F0;
        }
      `;

      form.shadowRoot.appendChild(style);
      form.dataset.ttStyled = 'true';
    }

    // An embed's shadow DOM attaches on hydration, which is NOT a mutation a
    // document-level observer can see — so relying on observer/initial-pass
    // timing styles forms only "sometimes" (random per refresh). Instead, for
    // any embed whose shadowRoot isn't ready yet, poll it (bounded) until it is.
    function ensureStyled(form, attempts) {
      if (form.dataset.ttStyled === 'true') return;

      if (form.shadowRoot) {
        injectStyle(form);
        delete form.dataset.ttPending;
        return;
      }

      if (attempts <= 0) {
        delete form.dataset.ttPending;
        return;
      }

      requestAnimationFrame(function () {
        ensureStyled(form, attempts - 1);
      });
    }

    // Style every embed on the page (there can be more than one), not just the first.
    function styleAll() {
      document.querySelectorAll(selector).forEach(function (form) {
        // Skip ones already styled or already waiting on their shadowRoot.
        if (form.dataset.ttStyled === 'true' || form.dataset.ttPending === 'true') return;

        form.dataset.ttPending = 'true';
        ensureStyled(form, 300); // ~5s at 60fps — covers slow hydration
      });
    }

    function init() {
      styleAll();

      // Catch embeds inserted later (e.g. extra form stages); the per-embed poll
      // above handles shadowRoot timing. Watch childList + attributes per the
      // project convention for third-party widgets.
      const observer = new MutationObserver(styleAll);

      observer.observe(document.body, { childList: true, subtree: true, attributes: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-with-purchase-code"] && !Shopify.designMode) return;
  try {
    class GWC extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form.gift-with-code__wrapper');
      this.form.addEventListener('submit', this.handleSubmit.bind(this));

      this.data = JSON.parse(this.querySelector('.gift-with-code__data').textContent).configurations;
      this.appliedCodes = JSON.parse(this.querySelector('.gift-with-code__data').textContent).codes || [];

      const removeButtons = this.querySelectorAll('button[data-remove-discount-code]');
      if (removeButtons.length) {
        removeButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const codeToRemove = button.getAttribute('data-remove-discount-code');
            this.removeDiscountCode(codeToRemove);
          });
        });
      }
    }

    handleSubmit(event) {
      event.preventDefault();

      const formData = new FormData(this.form);
      const discountCode = formData.get('discount').toLowerCase().trim();

      // Find the first matching configuration
      const matchingConfig = this.data.find(
        (config) => config.code.toLowerCase().trim() === discountCode && config.gift
      );

      if (matchingConfig) {
        try {
          this.addGiftToCart(matchingConfig.gift, discountCode);
        } catch (error) {
          console.error('Failed to add gift to cart:', error);
        }
      } else {
        console.log('No matching gift configuration found for code:', discountCode);
        this.applyDiscountCode(discountCode);
      }
    }

    addGiftToCart(id, code) {
      const formData = {
        items: [
          {
            id: id,
            quantity: 1,
            properties: {
              _gwp: 'true',
            },
          },
        ],
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase' });
          this.applyDiscountCode(code);
        })
        .catch((error) => console.error('Error adding gift:', error));
    }

    applyDiscountCode(code) {
      this.appliedCodes.push(code);
      const codesToApply = this.appliedCodes.join(',');
      const currentErrorElement = this.querySelector('.gift-with-code__error');
      if (currentErrorElement) currentErrorElement.textContent = '';

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: codesToApply }),
      })
        .then((response) => response.json())
        .then((response) => {
          const non_applicable_codes = response.discount_codes.filter((code) => code.applicable === false);

          if (non_applicable_codes.length) {
            const errorMessage = `${window.cartStrings.codeNotApplied} ${non_applicable_codes
              .map((code) => code.code)
              .join(', ')}`;

            document.addEventListener(
              'cart:updated',
              () => {
                const errorElement = document.querySelector('.gift-with-code__error');
                if (errorElement) errorElement.textContent = errorMessage;
              },
              { once: true }
            );
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase' });

          return;
        })
        .catch((error) => console.error('Error adding code:', error));
    }

    removeDiscountCode(code) {
      const codesToApply = this.appliedCodes.filter((c) => c !== code);
      const codes = codesToApply.length ? codesToApply.join(',') : '';
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ discount: codes }),
      })
        .then((response) => response.json())
        .then((response) => {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase' });
          return;
        })
        .catch((error) => console.error('Error removing code:', error));
    }
  }

  customElements.define('gift-with-code', GWC);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-with-purchase"] && !Shopify.designMode) return;
  try {
    class GWP extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.giftsToAdd = this.getAttribute('data-add-gifts');
      if (this.giftsToAdd) {
        this.giftsToAdd = this.giftsToAdd.split(',').filter((id) => id !== '');

        if (this.giftsToAdd.length) {
          const items = this.giftsToAdd.map((id) => ({
            id: id,
            quantity: 1,
            properties: {
              _gwp: 'true',
            },
          }));

          const formData = {
            items: items,
          };

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((response) => {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gift-with-purchase' });
            })
            .catch((error) => console.error('Error adding gift:', error));
        }
      }
    }
  }

  customElements.define('gift-with-purchase', GWP);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.grid-section__container--carousel').forEach((track) => {
      const scrollWrapper = track.closest('.grid-section--scroll-wrapper');
      if (!scrollWrapper) return;

      const controls = scrollWrapper.parentElement.querySelector('.grid-scroll-controls');
      if (!controls) return;

      const btnLeft = controls.querySelector('.scroll-left');
      const btnRight = controls.querySelector('.scroll-right');
      const progressBar = controls.querySelector('.grid-scroll-progress-bar');

      const scrollStep = track.querySelector('.shopify-block')?.offsetWidth || 250;

      let isDown = false;
      let startX = 0;
      let startScrollLeft = 0;

      const startDrag = (x) => {
        isDown = true;
        track.classList.add('dragging');
        startX = x;
        startScrollLeft = scrollWrapper.scrollLeft;
      };

      const onDrag = (x) => {
        if (!isDown) return;
        const walk = (x - startX) * 1.2;
        scrollWrapper.scrollLeft = startScrollLeft - walk;
      };

      const stopDrag = () => {
        isDown = false;
        track.classList.remove('dragging');
      };

      track.addEventListener('mousedown', (e) => startDrag(e.pageX));
      track.addEventListener('mousemove', (e) => onDrag(e.pageX));
      track.addEventListener('mouseup', stopDrag);
      track.addEventListener('mouseleave', stopDrag);

      track.addEventListener('touchstart', (e) => startDrag(e.touches[0].clientX));
      track.addEventListener('touchmove', (e) => onDrag(e.touches[0].clientX));
      track.addEventListener('touchend', stopDrag);

      btnLeft?.addEventListener('click', () => {
        scrollWrapper.scrollBy({
          left: -scrollStep,
          behavior: 'smooth',
        });
      });

      btnRight?.addEventListener('click', () => {
        scrollWrapper.scrollBy({
          left: scrollStep,
          behavior: 'smooth',
        });
      });

      const updateProgress = () => {
        if (!progressBar) return;

        const visible = scrollWrapper.clientWidth;
        const total = scrollWrapper.scrollWidth;
        const scrolled = scrollWrapper.scrollLeft;

        const progress = total === 0 ? 0 : (scrolled + visible) / total;

        progressBar.style.width = `${Math.min(progress, 1) * 100}%`;
      };

      const updateButtons = () => {
        if (!btnLeft || !btnRight) return;

        const maxScroll = scrollWrapper.scrollWidth - scrollWrapper.clientWidth;

        btnLeft.disabled = scrollWrapper.scrollLeft <= 0;
        btnRight.disabled = scrollWrapper.scrollLeft >= maxScroll - 1;

        btnLeft.classList.toggle('disabled', btnLeft.disabled);
        btnRight.classList.toggle('disabled', btnRight.disabled);
      };

      scrollWrapper.addEventListener('scroll', () => {
        updateProgress();
        updateButtons();
      });

      window.addEventListener('resize', () => {
        updateProgress();
        updateButtons();
      });

      updateProgress();
      updateButtons();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    class Megamenu extends HTMLElement {
    constructor() {
      super();
      this.allItems = document.querySelectorAll('.mega-menu__item');
      this.allTriggers = document.querySelectorAll('.js-mega-toggle');
      this.closeButton = document.querySelectorAll('.mega-menu__close');
      this.menuItems = document.querySelectorAll('.mega-menu__item-view-section');
      this.menuTrigger = document.querySelectorAll('.js-mega-view-toggle');
      let lastScrollY = 0;
    }

    connectedCallback() {
      this.allTriggers.forEach((menuItemEl) => {
        menuItemEl.addEventListener('click', (e) => {
          e.preventDefault();
          if (!menuItemEl.classList.contains('active')) {
            this.menuItem = menuItemEl;
            this.menuId = menuItemEl.getAttribute('data-menu-id');
            this.showMegaMenu();
            this.showMegamenuItem();
          }
        });
      });

      this.menuTrigger.forEach((menuViewEl) => {
        menuViewEl.addEventListener('click', (e) => {
          e.preventDefault();
          if (!menuViewEl.classList.contains('active')) {
            this.viewId = menuViewEl.getAttribute('data-menu');
            this.showMegamenuView();
          }
        });
      });

      this.closeButton.forEach((closeBtn) => {
        closeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.forceHideMegaMenu();
        });
      });

      document.body.addEventListener('click', (e) => {
        this.hideMegaMenu(e);
      });
    }

    showMegaMenu() {
      setTimeout(() => {
        if (document.body.classList.contains('megamenu--active')) {
          this.classList.remove('active');
          document.body.classList.remove('blur');
          document.body.classList.remove('megamenu--active');
        } else {
          this.classList.add('active');
          document.body.classList.add('blur');
          document.body.classList.add('megamenu--active');
        }
      }, 50);
    }

    showMegamenuItem() {
      this.allItems.forEach((item) => {
        item.classList.remove('active');
      });
      this.allTriggers.forEach((trigger) => {
        trigger.classList.remove('active');
      });
      this.menuItem.classList.add('active');

      const currentItem = document.querySelector(`.mega-menu__item[data-menu-id="${this.menuId}"]`);
      if (currentItem) {
        currentItem.classList.add('active');
      }
    }

    showMegamenuView() {
      this.menuItems.forEach((menuView) => {
        menuView.classList.add('hidden');
      });
      this.menuTrigger.forEach((menuViewEl) => {
        menuViewEl.classList.remove('active');
      });
      const currentView = document.querySelector(`.mega-menu__item-view-section[data-menu-id="${this.viewId}"]`);
      const currentTrigger = document.querySelector(`.js-mega-view-toggle[data-menu="${this.viewId}"]`);
      if (currentView) {
        currentView.classList.remove('hidden');
      }
      if (currentTrigger) {
        currentTrigger.classList.add('active');
      }
    }

    forceHideMegaMenu(e) {
      this.classList.remove('active');
      document.body.classList.remove('blur', 'megamenu--active');
      this.menuItem?.classList.remove('active');
    }

    hideMegaMenu(e) {
      if (document.body.classList.contains('megamenu--active') && !e.target.closest('mega-menu')) {
        this.classList.remove('active');
        document.body.classList.remove('blur', 'megamenu--active');
        this.menuItem.classList.remove('active');
      }
    }
  }

  customElements.define('mega-menu', Megamenu);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swym-header-icon"] && !Shopify.designMode) return;
  try {
    function renderWishlistCounter(swat) {
	  var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter");
    if (counter_elem) {
      for (var i = 0; i < counter_elem.length; i++) {
        if (swat.renderWishlistCount) {
          swat.renderWishlistCount(counter_elem[i], function(count, element) {
            count > 0 ? element.style.display = 'flex' : element.style.display = 'none';
          });
        }
      }
    }
  }

  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  window.SwymCallbacks.push(renderWishlistCounter);
  } catch(e) { console.error(e); }
})();

})();
